import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import numeral from 'numeral';
import Tooltip from 'components/Tooltip';
import {PROCESSING, FINISHED, ERRORED} from '../mixins/JobMixin';
import RemoveImageModal from './RemoveImageModal';

const ImageCard = createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    jobState: PropTypes.oneOf([PROCESSING, FINISHED, ERRORED]).isRequired,
    isDeleting: PropTypes.bool.isRequired,
    workingSetImage: ImmutablePropTypes.record.isRequired,
    onDeleteImage: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      imageFocused: false,
      removeFocused: false,
      showConfirmation: false,
    };
  },

  handleShowConfirmRemoveImage(event) {
    event.preventDefault();

    this.setState({showConfirmation: true});
  },

  handleRemoveImageCanceled() {
    this.setState({showConfirmation: false});
  },

  handleRemoveImageConfirmed(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    this.setState({showConfirmation: false}, () => {
      this.props.onDeleteImage(this.props.workingSetImage);
    });
  },

  handleImageFocused() {
    this.setState({imageFocused: !this.state.imageFocused});
  },

  handleRemoveFocused(event) {
    this.setState({removeFocused: !this.state.removeFocused});
  },

  renderRemoveImageModal() {
    return (
      <RemoveImageModal
        show={this.state.showConfirmation}
        workingSetImage={this.props.workingSetImage}
        onRemovedImage={this.handleRemoveImageConfirmed}
        onClosed={this.handleRemoveImageCanceled}
      />
    );
  },

  renderAssetRemove() {
    const {removeFocused} = this.state;
    const removeTooltip = (removeFocused) ? <Tooltip content="Delete Image" icon="ficon-trash" /> : null;

    return (
      <div
        className="asset-remove cursor-pointer"
        onClick={this.handleShowConfirmRemoveImage}
        onMouseOver={this.handleRemoveFocused}
        onMouseOut={this.handleRemoveFocused}
      >
        {removeTooltip}
        <i className="ficon ficon-times"></i>
      </div>
    );
  },

  renderFailedAssetRemove() {
    const {removeFocused} = this.state;
    const removeTooltip = (removeFocused) ? <Tooltip content="Clear" icon="ficon-times" /> : null;

    return (
      <div
        className="asset-remove cursor-pointer"
        onClick={this.handleShowConfirmRemoveImage}
        onMouseOver={this.handleRemoveFocused}
        onMouseOut={this.handleRemoveFocused}
      >
        {removeTooltip}
        <i className="ficon ficon-times"></i>
      </div>
    );
  },

  renderTransitional(workingSetImage, label) {
    return (
      <div className="asset asset-processing asset-image asset-image-processing br-a">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm"></i>
          <span className="block word-wrap p-xs-x-md">{`${label} ${workingSetImage.name}`}</span>
        </div>
      </div>
    );
  },

  renderProcessing(workingSetImage) {
    return this.renderTransitional(workingSetImage, 'optimizing');
  },

  renderDeleting(workingSetImage) {
    return this.renderTransitional(workingSetImage, 'deleting');
  },

  renderErrored(workingSetImage) {
    return (
      <div className="asset asset-image asset-error asset-image-failed br-a" onMouseOver={this.handleImageFocused} onMouseOut={this.handleImageFocused}>
        {this.renderRemoveImageModal()}

        <div className="asset-inner text-xs-center line-height-sm">
          <span className="block text-danger word-wrap p-xs-x-md">Upload of {workingSetImage.name} failed.</span>
          <Link to={`/kits/${this.props.kitToken}/images/upload`} className="text-danger block">Try again</Link>
        </div>

        {this.renderFailedAssetRemove()}
      </div>
    );
  },

  renderFinished(workingSetImage) {
    const {imageFocused} = this.state;
    const editTooltip = (imageFocused) ? <Tooltip content={`Edit ${workingSetImage.name}`} icon="ficon-pencil" /> : null;
    const percentSaved = workingSetImage.optimizedSize / workingSetImage.originalSize * 100;

    return (
      <Link to={`/kits/${this.props.kitToken}/images/${workingSetImage.id}`} className="asset asset-image link-dashed-none">
        {this.renderRemoveImageModal()}

        <div className="asset-inner" onMouseOver={this.handleImageFocused} onMouseOut={this.handleImageFocused}>
          {editTooltip}
          <div className="asset-preview bg-img-checkered">
            <img className="asset-source" src={workingSetImage.optimizedUrl} alt={workingSetImage.name} />
          </div>

          <div className="asset-performance image-performance-sm bg-gray-lighter m-xs-b-sm">
            <div className="image-performance-value br-r bg-primary" style={{width: `${percentSaved}%`}}></div>
          </div>

          <div className="asset-label text-sm gg">
            <div className="gg-col gg-col-1 p-xs-r-0">
              <p className="m-xs-b-0 text-truncate">
                {workingSetImage.name}
              </p>
            </div>

            <div className="gg-col gg-col-1 text-xs-right">
              <p className="text-nowrap m-xs-b-0">
                <span className="sr-only">File size: </span>
                <span className="text-primary">{numeral(workingSetImage.optimizedSize).format('0.0 b')}</span>
                <span className="text-muted m-xs-l-xs text-strike">{numeral(workingSetImage.originalSize).format('0.0 b')}</span>
              </p>
            </div>
          </div>
        </div>

        {this.renderAssetRemove()}
      </Link>
    );
  },

  render() {
    const {workingSetImage, jobState, isDeleting} = this.props;

    let value = null;

    switch (workingSetImage.status) {
      case "finished":
        value = this.renderFinished(workingSetImage);
        break;
      case "errored":
        value = this.renderErrored(workingSetImage);
        break;
      default:
        value = this.renderProcessing(workingSetImage);
    }

    if (isDeleting) {
      value = this.renderDeleting(workingSetImage);
    }

    return value;
  }
});

export default ImageCard;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImageCard.js